"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAttribute = void 0;
function parseAttribute(controller, attribute) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return JSON.parse(controller.element.dataset[attribute]);
}
exports.parseAttribute = parseAttribute;
